import { toast } from "sonner";
import { MessageCircle, Facebook, Link2, Share2 } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { priceLabel } from "./vehicleUtils";

export const shareUrl = (v) => `${process.env.REACT_APP_BACKEND_URL}/api/${v.item_type === "part" ? "p" : "v"}/${v.id}`;
export const pageUrl = (v) => (v.item_type === "part" ? `${window.location.origin}/vehicules?type=${v.kind}&p=${v.id}` : `${window.location.origin}/vehicules/${v.id}`);
export const shareText = (v, tv) => `${v.title} · ${tv.kind[v.kind]} · ${priceLabel(v, tv)}\n${shareUrl(v)}`;

export const nativeShare = async (v, tv) => {
  if (navigator.share) {
    try { await navigator.share({ title: v.title, text: `${v.title} · ${tv.kind[v.kind]} · ${priceLabel(v, tv)}`, url: shareUrl(v) }); return; } catch { /* annulé */ }
  }
  window.open(`https://wa.me/?text=${encodeURIComponent(shareText(v, tv))}`, "_blank", "noopener");
};

export const VehicleShare = ({ v, prefix = "vehicle-share" }) => {
  const { t } = useLanguage();
  const tv = t.vehicles;
  const s = t.news.share;
  const btn = "inline-flex items-center gap-2 rounded-full border border-brand/20 px-4 py-2 font-mono text-[11px] uppercase tracking-[0.2em] text-brand transition-colors hover:bg-mint";
  const copy = async () => { try { await navigator.clipboard.writeText(pageUrl(v)); toast.success(s.copied); } catch { toast.error(pageUrl(v)); } };
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={prefix}>
      <span className="mr-1 inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-[0.2em] text-brand-hover"><Share2 className="h-3.5 w-3.5" />{s.label}</span>
      <a href={`https://wa.me/?text=${encodeURIComponent(shareText(v, tv))}`} target="_blank" rel="noopener noreferrer" data-testid={`${prefix}-whatsapp`} className={`${btn} hover:border-brand`}><MessageCircle className="h-3.5 w-3.5" />{s.whatsapp}</a>
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl(v))}`} target="_blank" rel="noopener noreferrer" data-testid={`${prefix}-facebook`} className={btn}><Facebook className="h-3.5 w-3.5" />{s.facebook}</a>
      <button type="button" onClick={copy} data-testid={`${prefix}-copy`} className={btn}><Link2 className="h-3.5 w-3.5" />{s.copy}</button>
    </div>
  );
};
